import { FooterNav } from '@petsmart-ui/sparky';
import { dataLayerPush, layoutEvents } from '@libs/analytics';
import type { LinkAction } from '../../../types';

export function FooterSubCategories({ categories }: { categories?: LinkAction[] }) {
    const flatLinks = categories?.map(linkAction => ({
        actionText: linkAction.actionText,
        sysId: linkAction.link?.sysId,
        webUrl: linkAction.link?.webUrl,
    }));

    return flatLinks?.map(({ actionText, sysId, webUrl }) => (
        <FooterNav.Item
            onClick={() =>
                dataLayerPush({
                    ...layoutEvents.footerClick,
                    selection: actionText,
                    link_url: webUrl,
                })
            }
            href={webUrl}
            key={sysId}
            text={actionText}
        />
    ));
}
